import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import Header from '../Header/Header';
import About from './About.page/About.page';
import HeroPage from './Hero.page/Hero.page';
import Reason from './Reason.page/Reason.page';
import ReviewsPage from './Reviews.page/Reviews.page';
import ContactPage from './Contact.page/Contact.page';
import ServicesPage from './Services.page/Services.page';
import ExtrasLogo from './ExtrasLogo.page/ExtrasLogo.page';
import { resolveWorkshop } from '../../utils/resolveWorkshop';
import RepairyInboxWidget from '../RepairyInboxWidget/RepairyInboxWidget';

import css from './Home.module.css';

const Home = (props) => {
	const { id } = useParams();
	const location = useLocation();
	const host = window.location.hostname;
	const workshop = resolveWorkshop(host, id);
	const isFound = workshop != null;

	useEffect(() => {
		if (!location.hash) return;
		const anchorId = location.hash.replace(/^#/, '');
		if (!anchorId) return;
		const el = document.getElementById(anchorId);
		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [location.pathname, location.hash]);

	if (workshop) {
		document.documentElement.style.setProperty(
			'--main-color',
			workshop.theme
		);
	}

	return (
		<div>
			{!isFound ? (
				<div>Cannot find what you are looking for</div>
			) : (
				<div>
					<Helmet>
						<title>{workshop.name}</title>
						<meta name="description" content={workshop.name} />
					</Helmet>
					<Header
						logo={workshop.logo}
						bookingLink={workshop.bookingLink}
					/>
					<div className={css.Home}>
						{/* <BannerPage /> */}
						<HeroPage
							name={workshop.name}
							intro={workshop.intro}
							heroImage={workshop.heroImage}
							bookingLink={workshop.bookingLink}
						/>
						{workshop.isExtraLogos && (
							<ExtrasLogo extraLogos={workshop.extraLogos} />
						)}

						<ServicesPage otherServices={workshop.otherServices} services={workshop.services} />
						<Reason reasons={workshop.reasons} />
						<ReviewsPage reviews={workshop.reviews} />
						<About about={workshop.about} />
						<ContactPage
							workshopName={workshop.name}
							extraLogos={workshop.extraLogos}
							contacts={workshop.contacts}
						/>
					</div>
					<RepairyInboxWidget workshop={workshop} />
				</div>
			)}
		</div>
	);
};
export default Home;
